export const locale = {
    lang: 'pt',
    data: {
      'WIZARD': {
        'TESTTITULO': 'WIZARD TITLE :V',
        'CARGANDO': 'Carregando produtos adquiridos',
        'CARGANDO_PULSOS': 'Carregamento de pulsos em processo',
        'SINPRODS': 'Você não adquiriu este produto',
        'EVALUADOR':{
          'TITUTLO':'Avaliador'
        },
        'LANDING': {
          'PRODUCTO': {
            'CERTIFICAR':{
              'TITULO': 'Bem-vindo ao CULTURAL GO!',
              'CURRENT': 'Este é o seu processo atual de pesquisa',
              'FINISHED': 'Este é um processo de pesquisa concluído',
              'RESULTS': {
                'CURRENT': 'Processo de pesquisa não concluído',
                // 'FINISHED': 'Finished survey process'
                'FINISHED': 'Este é o seu processo atual de pesquisa',
                'FINISHED5': 'Resultados do processo'
              }
            },
            'Amco':{
              'TITULO': 'BEM-VINDO AO AMCO',
              'CURRENT': 'Este é o atual processo amco',
              'FINALIZADO': 'Este é um processo amco completo',
              'RESULTS': {
                'CURRENT': 'Processo Amco não concluído',
                'FINISHED': 'Este é o processo de resultado atual',
                'FINISHED5': 'Resultados do processo'
              }
            },
            'Trabajo_digno':{
              'TITULO': 'BEM-VINDO AO TRABALHO DECENTE',
              'CURRENT': 'Este é o atual processo de trabalho decente',
              'FINALIZADO': 'Este é um processo de trabalho decente completo',
              'RESULTS': {
                'CURRENT': 'Processo de trabalho decente não terminado',
                'FINISHED': 'Este é o processo de resultado atual',
                'FINISHED5': 'Resultados do processo'
              }
            },
            'Primer_empleo':{
              'TITULO': 'BEM-VINDO AO PRIMEIRO EMPREGO',
              'CORRENTE': 'Este é o atual primeiro processo de emprego',
              'FINALIZADO': 'Este é um processo de primeiro trabalho concluído',
              'RESULTS': {
                'CURRENT': 'Primeiro processo de emprego não concluído',
                'FINISHED': 'Este é o processo de resultado atual',
                'FINISHED5': 'Resultados do processo',
              }
            },
            'CERTIFICAR_C1':{
              'TITULO': 'Bem-vindo ao CULTURAL GO!',
              'CURRENT': 'Este é o seu processo atual de pesquisa',
              'FINISHED': 'Este é um processo de pesquisa concluído',
              'RESULTS': {
                'CURRENT': 'Processo de pesquisa não concluído',
                // 'FINISHED': 'Finished survey process'
                'FINISHED': 'Este é o seu processo atual de pesquisa',
                'FINISHED5': 'Resultados do processo'
              }
            },
            'CERTIFICAR_C2':{
              'TITULO': 'Bem-vindo ao CULTURAL GO!',
              'CURRENT': 'Este é o seu processo atual de pesquisa',
              'FINISHED': 'Este é um processo de pesquisa concluído',
              'RESULTS': {
                'CURRENT': 'Processo de pesquisa não concluído',
                // 'FINISHED': 'Finished survey process'
                'FINISHED': 'Este é o seu processo atual de pesquisa',
                'FINISHED5': 'Resultados do processo'
              }
            },
            'CERTIFICAR_C3':{
              'TITULO': 'Bem-vindo ao CULTURAL GO!',
              'CURRENT': 'Este é o seu processo atual de pesquisa',
              'FINISHED': 'Este é um processo de pesquisa concluído',
              'RESULTS': {
                'CURRENT': 'Processo de pesquisa não concluído',
                // 'FINISHED': 'Finished survey process'
                'FINISHED': 'Este é o seu processo atual de pesquisa',
                'FINISHED5': 'Resultados do processo'
              }
            },
            'CERTIFICAR_C4':{
              'TITULO': 'BEM-VINDO A CERTIFICAR A PRATA',
              'CURRENT': 'Este é o seu processo atual de pesquisa',
              'FINISHED': 'Este é um processo de pesquisa concluído',
              'RESULTS': {
                'CURRENT': 'Processo de pesquisa não concluído',
                // 'FINISHED': 'Finished survey process'
                'FINISHED': 'Este é o seu processo atual de pesquisa',
                'FINISHED5': 'Resultados do processo'
              }
            },
            'MEDIR':{
              'TITULO': 'BEM-VINDO À MEDIÇÃO',
              'CURRENT': 'Este é o seu processo de medição atual',
              'FINISHED': 'Este é um processo de medição concluído',
              'RESULTS': {
                'CURRENT': 'Processo de medição não concluído',
                // 'FINISHED': 'Finished measurement process'
                'FINISHED': 'Este é o seu processo de medição atual',
                'FINISHED5': 'Resultados do processo'

              }
            },
            'MEDIR_M1':{
              'TITULO': 'BEM-VINDO À MEDIÇÃO MELHORADA',
              'CURRENT': 'Este é o seu processo de medição atual',
              'FINISHED': 'Este é um processo de medição concluído',
              'RESULTS': {
                'CURRENT': 'Processo de medição não concluído',
                'FINISHED': 'Processo de medição finalizado'
              }
            },
            'MEDIR_M2':{
              'TITULO': 'BEM-VINDO À MEDIÇÃO + MST',
              'CURRENT': 'Este é o seu processo de medição atual',
              'FINISHED': 'Este é um processo de medição concluído',
              'RESULTS': {
                'CURRENT': 'Processo de medição não concluído',
                'FINISHED': 'Processo de medição finalizado'
              }
            },
            'MEDIR_M3':{
              'TITULO': 'BEM-VINDO À MEDIÇÃO POR ÁREAS',
              'CURRENT': 'Este é o seu processo de medição atual',
              'FINISHED': 'Este é um processo de medição concluído',
              'RESULTS': {
                'CURRENT': 'Processo de medição não concluído',
                'FINISHED': 'Processo de medição finalizado'
              }
            },
            'MEDIR_M4':{
              'TITULO': 'BEM-VINDO À MEDIÇÃO DOS LÍDERES',
              'CURRENT': 'Este é o seu processo de medição atual',
              'FINISHED': 'Este é um processo de medição concluído',
              'RESULTS': {
                'CURRENT': 'Processo de medição não concluído',
                'FINISHED': 'Processo de medição finalizado'
              }
            },
            'MEDIR_M5':{
              'TITULO': 'BEM-VINDO À MEDIÇÃO POR DIMENSÕES',
              'CURRENT': 'Este é o seu processo de medição atual',
              'FINISHED': 'Este é um processo de medição concluído',
              'RESULTS': {
                'CURRENT': 'Processo de medição não concluído',
                'FINISHED': 'Processo de medição finalizado'
              }
            },
            'MEDIR_M6':{
              'TITULO': 'BEM-VINDO À MEDIÇÃO PARA CERTIFICAR',
              'CURRENT': 'Este é o seu processo de medição atual',
              'FINISHED': 'Este é um processo de medição concluído',
              'RESULTS': {
                'CURRENT': 'Processo de medição não concluído',
                'FINISHED': 'Processo de medição finalizado'
              }
            },
            'PULSE':{
              'TITULO': 'BEM-VINDO À PULSE CHECK',
              'ADMINTITULO': 'ADMINISTRATOR  PULSE CHECK´S',
              'PRODU': 'Pulse Check',
              'CURRENT': 'This is your current Pulse Check process',
              'PULSOS': 'This is a Pulse Check process',
              'FINISHED': 'This is a finished Pulse Check process',
              'ENTRAR': 'Começar',
              'CARGANDO_PULSE':'Carregamento de checagens pulsáteis em processo',
              'RESULTS': {
                'CURRENT': 'Pulse Check process not finished',
                // 'FINISHED': 'Finished Pulse Check process'
                'FINISHED': 'This is your current Pulse Check process'
              }
            },
            'FOCUS':{
              'SECTION': 'Groups administrator',
              'TITLE': 'Groups administrator',
              'SUBTI': 'Selection or creation of groups',
              'LAND': {
                'NAME': 'Survey name',
                'INICIO': 'Começar date',
                'FIN': 'Target date',
                'AVANCE': 'Advance',
                'ESTADO': 'Status',
                'COMP': 'Behavior',
                'CREARENC': 'Create survey',
                'DELETE': 'Delete',
                'EDIT': 'Edit',
              },
              'TITULO': 'WELCOME TO FOCUS AREA',
              'CURRENT': 'This is your current focus area process',
              'FINISHED': 'This is a finished focus area process',
              'RESULTS': {
                'CURRENT': 'Focus Area process not finished',
                'FINISHED': 'Finished Focus Area process'
              }
            },
            'FOCUS_1':{
              'SECTION': 'Groups administrator',
              'TITLE': 'Groups administrator',
              'SUBTI': 'Selection or creation of groups',
              'ADMINTITULO': 'ÁREAS DE FOCO DO ADMINISTRADOR',
              'PRODU': 'Área de foco',
              'CARGANDO_FOCUS':'Carregamento da área de foco em processo',
              'TAB_PROC_FOC':'Processos das áreas de foco',
              'TAB_SUBIDA_COLB_FOC':'Carregamento de colaborador',
              'INST_MOD_FILTER_1':'Carregue a sua lista de colaboradores',
              'INST_MOD_FILTER_2':'Introduza o inquérito à sua escolha',
              'LAND': {
                'NAME': 'Survey name',
                'INICIO': 'Começar date',
                'FIN': 'Target date',
                'AVANCE': 'Advance',
                'ESTADO': 'Status',
                'COMP': 'Behavior',
                'CREARENC': 'Create survey',
                'DELETE': 'Delete',
                'EDIT': 'Edit',
              },
              'TITULO': 'WELCOME TO FOCUS AREA',
              'CURRENT': 'This is your current focus area process',
              'FINISHED': 'This is a finished focus area process',
              'RESULTS': {
                'CURRENT': 'Focus Area process not finished',
                'FINISHED': 'Finished Focus Area process'
              }
            },
            'MEDIR_M9':{
              'TITULO': 'BEM-VINDO AO INMOTION SURVEY',
              'CURRENT': 'This is your current product process',
              'FINISHED': 'This is a finished product process',
              'RESULTS': {
                'CURRENT': 'Product process not finished',
                'FINISHED': 'Finished product process'
              }
            },
          },
          'DONE': 'Ano de aplicação: ',
          'LEGA': 'Legacy results',
          'FOCUS': 'SURVEY´S TO FOCUS AREA',
          'ENTRAR': 'Começar',
          ////instituto turquia///
          'INST-TURQUEY':{
            'TITULO':'Culture Brief ve Culture Audit 5.0',
            'TITULO-1':'Culture Brief ve Culture Audit 5.0',
            'TITULO1':'Culture Brief ve Culture Audit 5.0',
            'TITULO2':'Culture Brief 5.0',
            'TITULO3':'Culture Audit 5.0',
            'TITULO4':'Lista Especial',

          },
          'INST-CHINA':{
            'TITULO':'Auditoria de Cultura',
            'TITULO1':'Auditoria de Cultura',
            'TITULO2':'Auditoria de Cultura 5.0',
            'TITULO3':'Auditoria de Cultura SP',
          },
          'INST-ESP':{
            'TITULO':'Auditoria de Cultura',
            'TITULO1':'Auditoria de Cultura',
            'TITULO2':'Auditoria de Cultura 5.0',
            'TITULO3':'Plano de ação',
          }
        },
        'STEPSTAT': {
          'LOCK': 'Step locked',
          'PEND': 'Step open',
          'COMP': 'Step completed'
        },
        'NOPRODUCTS': {
          'TITULO': 'Your company has no acquired products',
          'SUBTI': 'Information about the offer'
        },
        'GUIA35': {
          'TITULO': 'Guide NOM-035-STPS-2018',
          'SUBTITULO':'Description',
          'DESCRIPCION': 'Information about NOM-035-STPS-2018',
          'ENTRAR': 'START'
         },
        'ENCUESTA35': {
          'TITULO': 'Pollster NOM-035-STPS-2018',
          'TITULO2': 'Pollster NOM-035-STPS-2018',
          'SUBTITULO':'Description',
          'DESCRIPCION': 'The following section belongs to a surveyor of NOM-035-STPS-2018, in which the different psychosocial risk factors in the organizational environment of workers will be identified',
          'ENTRAR': 'START'
        },
        'Amco': {
          'TITULO': 'Amco',
        },
        'Trabajo_digno': {
            'TITULO': 'Trabalho decente',
          },
          'Primer_empleo': {
            'TITULO': 'Primeiro trabalho',
          },
          'NOM35V3': {
              'TITULO': 'Norma 035 3.0'
          },
          'CERTIFICAR_C4': {
              'TITULO': 'Certificado de prata'
          },
        'CERTIFICAR': {
          'TITULO': 'Certificar',
          'STEPS': {
            'STP1': {
              'WIZBT': 'línguas',
              'TITULO': 'línguas',
              'SUBTI': 'Seleção de idiomas'
            },
            'STP_NPS': {
              'WIZBT': 'NPS',
              'TITULO': 'NPS',
              'SUBTI': 'Edição NPS'
            },
            'STP1-1': {
              'WIZBT': 'Reagentes',
              'TITULO': 'Reagentes',
              'SUBTI': 'Seleção de reagentes'
            },
            'STP1-FOCUS-PLANTILLA': {
              'WIZBT': 'Modelos',
              'TITULO': 'Modelos',
              'SUBTI': 'Seleção de reagentes'
            },
            'STP2': {
              'WIZBT': '4LL as práticas',
              'TITULO': '4LL as práticas',
              'SUBTI': 'Introdução às práticas do 4ALL'
            },
            'STP_CONTROL': {
              'WIZBT': 'Pergunta de controle',
              'TITULO': 'Pergunta de controle',
              'SUBTI': 'Editando a pergunta de controle'
            },
            'STP3': {
              'WIZBT': 'Demográfico',
              'TITULO': 'Demográfico',
              'SUBTI': 'Digite as informações demográficas para usar na pesquisa. NOTA: Informações demográficas em amarelo são opcionais'
            },
            'STP3-1': {
              'WIZBT': 'Perguntas abertas',
              'TITULO': 'Perguntas abertas',
              'SUBTI': 'Digite as perguntas em aberto'
            },
            'STP4': {
              'WIZBT': 'Adicional',
              'TITULO': 'Adicional',
              'SUBTI': 'Inserindo perguntas adicionais'
            },
            'STP4-FOCUS-PLANTILLA': {
              'WIZBT': 'Personalizados',
              'TITULO': 'Personalizados',
              'SUBTI': 'Inserindo perguntas Personalizados'
            },
            'STP4-1': {
              'WIZBT': 'Gerar pesquisa',
              'TITULO': 'Gerar pesquisa',
              'SUBTI': 'Gere a pesquisa',
              'WIZBT2': 'Pesquisa',
              'TITULO2': 'Pesquisa',
            },
            'STP5': {
              'WIZBT': 'Colaboradores',
              'TITULO': 'Colaboradores',
              'SUBTI': 'Carregamento da lista de colaboradores'
            },
            'STP6': {
              'WIZBT': 'Agendar pesquisa',
              'TITULO': 'Agendar pesquisa',
              'SUBTI': 'Agende a data de lançamento e lembretes da pesquisa'
            },
            'STP7': {
              'WIZBT': 'Enviando e-mails',
              'TITULO': 'Enviando e-mails',
              'SUBTI': 'Envie o convite aos seus colaboradores para realizar a pesquisa'
            },
            // 'STP8': {
            //   'WIZBT': 'Encerramento da pesquisa',
            //   'TITULO': 'Encerramento da pesquisa',
            //   'SUBTI': 'Progresso antes do fechamento da pesquisa'
            // },
            'STP8': {
              'WIZBT': 'Seguimento do inquérito',
              'TITULO': 'Seguimento do inquérito',
              'SUBTI': 'Progresso antes do fechamento da pesquisa'
            },
            'STP9': {
              'WIZBT': 'Activar o inquérito',
              'TITULO': 'Activar o inquérito',
              'SUBTI': 'Activar o inquérito'
            },
            'STP10': {
              'WIZBT': 'Plantilla',
              'TITULO': 'Fazer modificações no Modelo',
              'SUBTI': 'Plantilla'
            },
            'STP_VOICE': {
              'WIZBT': 'Configurações de voz',
              'TITULO': 'Defina as configurações de voz para a pesquisa com áudio',
              'SUBTI': 'Defina as configurações de voz para a pesquisa com áudio'
            }
          }
        },
        'CERTIFICARAMCO': {
          'TITULO': 'AMCO',
        },
        'CERTIFICARTRABADIG': {
          'TITULO': 'Trabalho decente',
        },
        'CERTIFICARADICPRIEMPL': {
          'TITULO': 'Primeiro emprego',
        },
        'CERTIFICAR_C2': {
          'TITULO': 'Izzi',
        },
        'CERTIFICAR35': {
          'TITULO': 'NOM-035-STPS-2018',
          'LANDING': {
            'TITULO': 'WELCOME TO NOM-035-STPS-2018',
            'DONE': 'Ano de aplicação: ',
            'ENTRAR': 'Começar'
          },
          'STEPS': {
            'STP1': {
              'WIZBT': 'Languages',
              'TITULO': 'Languages',
              'SUBTI': 'Languages selection'
            },
            'STP2': {
              'WIZBT': 'For All Practices',
              'TITULO': 'For All Practices',
              'SUBTI': 'Insert the For All practices of your company for the survey'
            },
            'STP3': {
              'WIZBT': 'Demographics',
              'TITULO': 'Demographics',
              'SUBTI': 'Insert the demographics information to be shown in the survey'
            },
            'STP4': {
              'WIZBT': 'Additionals',
              'TITULO': 'Additionals',
              'SUBTI': 'Insert additional questions for the survey'
            },
            'STP5': {
              'WIZBT': 'Participants',
              'TITULO': 'Participants',
              'SUBTI': 'You have not loaded your participants database'
            },
            'STP6': {
              'WIZBT': 'Schedule survey',
              'TITULO': 'Schedule survey',
              'SUBTI': 'Schedule the survey\'s launching and reminders dates'
            },
            'STP7': {
              'WIZBT': 'Mail sender',
              'TITULO': 'Mail sender',
              'SUBTI': 'Send the survey invitation to your collaborators'
            },
            'STP8': {
              'WIZBT': 'Survey close',
              'TITULO': 'Survey close',
              'SUBTI': 'Progress before the closing of the survey'
            },'STP9':{
              'WIZBT': 'Communication plan',
              'TITULO': 'Communication plan',
              'SUBTI': 'Send the survey invitation to your collaborators'
            },'STP10':{
              'WIZBT': 'Participants',
              'TITULO': 'Participants',
              'SUBTI': 'Get ready for the NOM-035-STPS-2018 Survey '
            }
          }
        },
        'PULSE': {
          'TITULO': 'Pulse Check',
          'LANDING': {
            'TITULO': 'WELCOME TO PULSE CHECK',
            'DONE': 'Ano de aplicação: ',
            'ENTRAR': 'Começar'
          },
          'STEPS': {
            // 'STP1': {
            //   'WIZBT': 'Languages',
            //   'TITULO': 'Languages',
            //   'SUBTI': 'Languages selection',
            // },
            // 'STP1-1': {
            //   'WIZBT': 'Statements',
            //   'TITULO': 'Statements',
            //   'SUBTI': 'Statements selection'
            // },
            // 'STP2': {
            //   'WIZBT': 'For All practices',
            //   'TITULO': 'For All practices',
            //   'SUBTI': 'Insert the For All practices of your company for the survey'
            // },
            // 'STP3': {
            //   'WIZBT': 'Demographics',
            //   'TITULO': 'Demographics',
            //   'SUBTI': 'Insert the demographics information to be shown in the survey'
            // },
            // 'STP3-1': {
            //   'WIZBT': 'Open questions',
            //   'TITULO': 'Open questions',
            //   'SUBTI': 'Insert the open questions'
            // },
            // 'STP4': {
            //   'WIZBT': 'Additionals',
            //   'TITULO': 'Additionals',
            //   'SUBTI': 'Insert additional questions for the survey'
            // },
            // 'STP5': {
            //   'WIZBT': 'Participants',
            //   'TITULO': 'Participants',
            //   'SUBTI': 'Upload your company collaborators database'
            // },
            'STP6': {
              'WIZBT': 'Schedule survey',
              'TITULO': 'Schedule survey',
              'SUBTI': 'Schedule survey dates Pulse Check'
            },
            'STP7': {
              'WIZBT': 'Mail sender',
              'TITULO': 'Mail sender',
              'SUBTI': 'Send the survey invitation to your collaborators'
            },
            'STP8': {
              'WIZBT': 'Survey progress',
              'TITULO': 'Survey progress',
              'SUBTI': 'Check the progress of the surveys Pulse Check',
            }
          }
        },
        'CERTIFICAR_C1': {
          'TITULO': 'Alternative Certify',
          'LANDING': {
            'TITULO': 'WELCOME TO ALTERNATIVE CERTIFY',
            'DONE': 'Ano de aplicação: ',
            'ENTRAR': 'Começar'
          }
        },
        'MEDIR': {
          'TITULO': 'Measurement',
          'LANDING': {
            'TITULO': 'WELCOME TO MEASUREMENT',
            'DONE': 'Ano de aplicação: ',
            'ENTRAR': 'Começar'
          }
        },
        'MEDIR_M1': {
          'TITULO': 'Measurement enhanced',
          'LANDING': {
            'TITULO': 'WELCOME TO MEASUREMENT ENHANCED',
            'DONE': 'Ano de aplicação: ',
            'ENTRAR': 'Começar'
          }
        },
        'MEDIR_M2': {
          'TITULO': 'Measurement + MST',
          'LANDING': {
            'TITULO': 'WELCOME TO MEASUREMENT + MST',
            'DONE': 'Ano de aplicação: ',
            'ENTRAR': 'Começar'
          }
        },
        'MEDIR_M3': {
          'TITULO': 'Measurement by areas',
          'LANDING': {
            'TITULO': 'WELCOME TO MEASUREMENT BY AREAS',
            'DONE': 'Ano de aplicação: ',
            'ENTRAR': 'Começar'
          }
        },
        'MEDIR_M4': {
          'TITULO': 'Measurement by leaders',
          'LANDING': {
            'TITULO': 'WELCOME TO MEASUREMENT BY LEADERS',
            'DONE': 'Ano de aplicação: ',
            'ENTRAR': 'Começar'
          }
        },
        'MEDIR_M5': {
          'TITULO': 'Measurement by dimensions',
          'LANDING': {
            'TITULO': 'WELCOME TO MEASUREMENT BY DIMENSIONS',
            'DONE': 'Ano de aplicação: ',
            'ENTRAR': 'Começar'
          }
        },
        'MEDIR_M6': {
          'TITULO': 'Measurement to certify',
          'LANDING': {
            'TITULO': 'WELCOME TO MEASUREMENT TO CERTIFY',
            'DONE': 'Ano de aplicação: ',
            'ENTRAR': 'Começar'
          }
        },
        'MEDIR_M9': {
          'TITULO': 'Inquérito de lnmotion',
          'LANDING': {
            'TITULO': 'BEM-VINDO AO INMOTION SURVEY',
            'DONE': 'Ano de aplicação: ',
            'ENTRAR': 'Começar'
          }
        },
        'FOCUS':{
          'TITULO': 'Focus Area',
          'LANDING': {
            'TITULO': 'WELCOME TO FOCUS AREA',
            'DONE': 'Ano de aplicação: ',
            'ENTRAR': 'Começar'
          },
          'STEPS': {
            'STP1': {
              'WIZBT': 'Languages',
              'TITULO': 'Languages',
              'SUBTI': 'Languages selection'
            },
            'STP2': {
              'WIZBT': 'Manage Groups',
              'TITULO': 'Manage Groups',
              'SUBTI': 'Insert the For All practices of your company for the survey'
            },
            'STP3': {
              'WIZBT': 'Administer Surveys',
              'TITULO': 'Administer Surveys',
              'SUBTI': 'Insert the demographics information to be shown in the survey'
            },
            'STP4': {
              'WIZBT': 'Survey Board',
              'TITULO': 'Survey Board',
              'SUBTI': 'Insert additional questions for the survey'
            }
          }
        },
        'LEADER_GO':{
          'TITULO_ADMIN': 'LÍDER GO® ADMINISTRADOR DE BOAS-VINDAS',
          'TITULO': 'LÍDER GO® BEM-VINDO',
          'TITULO_PRODUCT':'Leader Go® administrador',
          'TITULO_PRODUCT2':'Leader Go®',
          'LANDING': {
            'TITULO': 'BEM-VINDO A IR LÍDER',
            'DONE': 'Ano de aplicação:  ',
            'ENTRAR': 'Início'
          },
          'STEPS': {
            'STP1': {
              'WIZBT': 'Idiomas',
              'TITULO': 'Idiomas',
              'SUBTI': 'Seleção de idiomas'
            },
            'STP2': {
              'WIZBT': 'Seleção de Líderes',
              'TITULO': 'Seleção de Líderes',
              'SUBTI': 'Selecionar líderes',
            },
            'STP3': {
              'WIZBT': 'Mensagens de comunicação',
              'TITULO': 'Mensagens de comunicação',
              'SUBTI': 'Login para editar os e-mails',
            },
            'STP4': {
              'WIZBT': 'Confirmação',
              'TITULO': 'Confirmação',
              'SUBTI': 'Entre para confirmar o envio de e-mails',
            },
            'STP5': {
              'WIZBT': 'Avançar',
              'TITULO': 'Avançar',
              'SUBTI': 'Avançar'
            }
          }

        },
        'ACTION_GO':{
          'TITULO_ADMIN': 'ACTION GO® WELCOME ADMINISTRATOR',
          'TITULO': 'ACTION GO® WELCOME',
          'TITULO_PRODUCT':'Acção GO® administrador',
          'TITULO_PRODUCT2':'Acção GO®',
        },
        'LANDING_REQUERIMIENTOSV3':{
            'TITULO':'Requerimentos técnicos',
            'EXTERNAL_PORTAL': 'Copiar url RT externo',
            'COPYA_MESSAGE':'O url foi copiado para a área de transferência',

        },
        'GOFLOW':{
          'TITULO': 'Resultados GoFlow',
        },
      }
    }
};
